import React from "react";
import * as S from "./styles";
import { useHistory } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import Datalayer from "../../services/datalayer";

const GoBackButton = ({ dataLayerCategory, route, pageName }) => {
  let history = useHistory();

  const handleClick = () => {
    dataLayerCategory &&
      Datalayer.onClick(dataLayerCategory, "voltar", undefined);
    if (route) {
      history.push(route);
    } else {
      history.goBack();
    }
  };

  return (
    <S.Wrapper>
      <S.Icon>
        <FiArrowLeft
          id={"btn-component-botao_voltar"}
          name={"btn-component-botao_voltar"}
          onClick={handleClick}
        />
      </S.Icon>
      <S.PageTitle>{pageName}</S.PageTitle>
    </S.Wrapper>
  );
};

export default GoBackButton;
